var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "propertyDetails" } },
    [
      _c(
        "div",
        { ref: "scrollArea", staticClass: "section-content" },
        [
          _vm.selected
            ? [
                _c("div", { staticClass: "vo-card" }, [
                  _c("div", { staticClass: "vo-header" }, [
                    _vm._v("\n          Property Details\n        ")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "vo-content" }, [
                    _c("div", { staticClass: "vo-s-list" }, [
                      _c("div", { staticClass: "name" }, [_vm._v("Property")]),
                      _vm._v(" "),
                      _c("div", { staticClass: "value" }, [
                        _vm._v(_vm._s(_vm.selected.name))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "vo-s-list" }, [
                      _c("div", { staticClass: "name" }, [_vm._v("Address")]),
                      _vm._v(" "),
                      _c("div", { staticClass: "value" }, [
                        _c("div", [
                          _vm.selected.address.line2
                            ? _c("span", [
                                _vm._v(
                                  _vm._s(_vm.selected.address.line2) + " - "
                                )
                              ])
                            : _vm._e(),
                          _vm._v(_vm._s(_vm.selected.address.line1))
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            _vm._s(_vm.selected.address.city) +
                              ", " +
                              _vm._s(_vm.selected.address.province) +
                              " " +
                              _vm._s(_vm.selected.address.country)
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", [_vm._v(_vm._s(_vm.selected.address.postal))])
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "vo-footer" },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "vo-button",
                          attrs: { flat: "" },
                          on: {
                            click: function($event) {
                              _vm.routeAddQueries({
                                dialog: "property-manage",
                                dialogAction: "edit"
                              })
                            }
                          }
                        },
                        [
                          _c("v-icon", [_vm._v("mdi-pencil")]),
                          _vm._v(" "),
                          _c("span", [_vm._v("Edit")])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          staticClass: "vo-button red",
                          attrs: { flat: "" },
                          on: { click: _vm.deletePropertyDialog }
                        },
                        [
                          _c("v-icon", [_vm._v("mdi-delete")]),
                          _vm._v(" "),
                          _c("span", [_vm._v("Delete")])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _vm.hasPermissionsInProperty(["ticketAdmin"])
                  ? _c("div", { staticClass: "vo-card" }, [
                      _c("div", { staticClass: "vo-header" }, [
                        _vm._v("\n          Generate Report\n        ")
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "vo-content" },
                        [
                          _c(
                            "div",
                            [
                              _c("div", [_vm._v("From:")]),
                              _vm._v(" "),
                              _c(
                                "v-menu",
                                {
                                  ref: "fromDateInput",
                                  attrs: {
                                    lazy: "",
                                    "close-on-content-click": false,
                                    transition: "scale-transition",
                                    "offset-y": "",
                                    "full-width": "",
                                    "nudge-right": 40,
                                    "min-width": "290px",
                                    "return-value": _vm.report.fromDate.date
                                  },
                                  on: {
                                    "update:returnValue": function($event) {
                                      _vm.$set(
                                        _vm.report.fromDate,
                                        "date",
                                        $event
                                      )
                                    }
                                  },
                                  model: {
                                    value: _vm.report.fromDateMenu,
                                    callback: function($$v) {
                                      _vm.$set(_vm.report, "fromDateMenu", $$v)
                                    },
                                    expression: "report.fromDateMenu"
                                  }
                                },
                                [
                                  _c("v-text-field", {
                                    ref: "fromDateTextInput",
                                    attrs: {
                                      slot: "activator",
                                      label: "Click to select date",
                                      "prepend-icon": "event",
                                      readonly: "",
                                      rules: _vm.rules.report
                                    },
                                    slot: "activator",
                                    model: {
                                      value: _vm.report.fromDate.date,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.report.fromDate,
                                          "date",
                                          $$v
                                        )
                                      },
                                      expression: "report.fromDate.date"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "v-date-picker",
                                    {
                                      attrs: {
                                        color: "primary",
                                        "no-title": "",
                                        scrollable: ""
                                      },
                                      model: {
                                        value: _vm.report.fromDatePicker,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.report,
                                            "fromDatePicker",
                                            $$v
                                          )
                                        },
                                        expression: "report.fromDatePicker"
                                      }
                                    },
                                    [
                                      _c("v-spacer"),
                                      _vm._v(" "),
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: { flat: "", color: "primary" },
                                          on: {
                                            click: function($event) {
                                              _vm.report.fromDateMenu = false
                                            }
                                          }
                                        },
                                        [_vm._v("Cancel")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: { flat: "", color: "primary" },
                                          on: {
                                            click: function($event) {
                                              _vm.$refs.fromDateInput.save(
                                                _vm.report.fromDatePicker
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v("OK")]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-menu",
                                {
                                  ref: "fromTimeInput",
                                  attrs: {
                                    lazy: "",
                                    "close-on-content-click": false,
                                    transition: "scale-transition",
                                    "offset-y": "",
                                    "full-width": "",
                                    "nudge-right": 40,
                                    "max-width": "290px",
                                    "min-width": "290px",
                                    "return-value": _vm.report.fromDate.time
                                  },
                                  on: {
                                    "update:returnValue": function($event) {
                                      _vm.$set(
                                        _vm.report.fromDate,
                                        "time",
                                        $event
                                      )
                                    }
                                  }
                                },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      slot: "activator",
                                      label: "Click to select time",
                                      "prepend-icon": "access_time",
                                      readonly: ""
                                    },
                                    slot: "activator",
                                    model: {
                                      value: _vm.report.fromDate.time,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.report.fromDate,
                                          "time",
                                          $$v
                                        )
                                      },
                                      expression: "report.fromDate.time"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("v-time-picker", {
                                    attrs: { color: "primary" },
                                    on: {
                                      change: function($event) {
                                        _vm.$refs.fromTimeInput.save(
                                          _vm.report.fromTimePicker
                                        )
                                      }
                                    },
                                    model: {
                                      value: _vm.report.fromTimePicker,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.report,
                                          "fromTimePicker",
                                          $$v
                                        )
                                      },
                                      expression: "report.fromTimePicker"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("br"),
                              _vm._v(" "),
                              _c("div", [_vm._v("To:")]),
                              _vm._v(" "),
                              _c(
                                "v-menu",
                                {
                                  ref: "toDateInput",
                                  attrs: {
                                    lazy: "",
                                    "close-on-content-click": false,
                                    transition: "scale-transition",
                                    "offset-y": "",
                                    "full-width": "",
                                    "nudge-right": 40,
                                    "min-width": "290px",
                                    "return-value": _vm.report.toDate.date
                                  },
                                  on: {
                                    "update:returnValue": function($event) {
                                      _vm.$set(
                                        _vm.report.toDate,
                                        "date",
                                        $event
                                      )
                                    }
                                  },
                                  model: {
                                    value: _vm.report.toDateMenu,
                                    callback: function($$v) {
                                      _vm.$set(_vm.report, "toDateMenu", $$v)
                                    },
                                    expression: "report.toDateMenu"
                                  }
                                },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      slot: "activator",
                                      label: "Click to select date",
                                      "prepend-icon": "event",
                                      readonly: ""
                                    },
                                    slot: "activator",
                                    model: {
                                      value: _vm.report.toDate.date,
                                      callback: function($$v) {
                                        _vm.$set(_vm.report.toDate, "date", $$v)
                                      },
                                      expression: "report.toDate.date"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "v-date-picker",
                                    {
                                      attrs: {
                                        "no-title": "",
                                        color: "primary",
                                        scrollable: ""
                                      },
                                      model: {
                                        value: _vm.report.toDatePicker,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.report,
                                            "toDatePicker",
                                            $$v
                                          )
                                        },
                                        expression: "report.toDatePicker"
                                      }
                                    },
                                    [
                                      _c("v-spacer"),
                                      _vm._v(" "),
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: { flat: "", color: "primary" },
                                          on: {
                                            click: function($event) {
                                              _vm.report.toDateMenu = false
                                            }
                                          }
                                        },
                                        [_vm._v("Cancel")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: { flat: "", color: "primary" },
                                          on: {
                                            click: function($event) {
                                              _vm.$refs.toDateInput.save(
                                                _vm.report.toDatePicker
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v("OK")]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-menu",
                                {
                                  ref: "toTimeInput",
                                  attrs: {
                                    lazy: "",
                                    "close-on-content-click": false,
                                    transition: "scale-transition",
                                    "offset-y": "",
                                    "full-width": "",
                                    "nudge-right": 40,
                                    "max-width": "290px",
                                    "min-width": "290px",
                                    "return-value": _vm.report.toDate.time
                                  },
                                  on: {
                                    "update:returnValue": function($event) {
                                      _vm.$set(
                                        _vm.report.toDate,
                                        "time",
                                        $event
                                      )
                                    }
                                  }
                                },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      slot: "activator",
                                      label: "Click to select time",
                                      "prepend-icon": "access_time",
                                      readonly: ""
                                    },
                                    slot: "activator",
                                    model: {
                                      value: _vm.report.toDate.time,
                                      callback: function($$v) {
                                        _vm.$set(_vm.report.toDate, "time", $$v)
                                      },
                                      expression: "report.toDate.time"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("v-time-picker", {
                                    attrs: { color: "primary" },
                                    on: {
                                      change: function($event) {
                                        _vm.$refs.toTimeInput.save(
                                          _vm.report.toTimePicker
                                        )
                                      }
                                    },
                                    model: {
                                      value: _vm.report.toTimePicker,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.report,
                                          "toTimePicker",
                                          $$v
                                        )
                                      },
                                      expression: "report.toTimePicker"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              staticClass: "button",
                              attrs: {
                                loading: _vm.report.lockout,
                                color: "primary"
                              },
                              on: {
                                click: function($event) {
                                  _vm.generateReport()
                                }
                              }
                            },
                            [_vm._v("download report")]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "clear" })
                        ],
                        1
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "vo-card" }, [
                  _c("div", { staticClass: "vo-header" }, [
                    _vm._v("Manager Tools")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "tools" },
                    _vm._l(_vm.managerTools, function(tool, key) {
                      return _vm.hasPermissionsInProperty(
                        tool.permissions,
                        _vm.selected._id
                      )
                        ? _c(
                            "div",
                            {
                              directives: [
                                { name: "ripple", rawName: "v-ripple" }
                              ],
                              key: key,
                              staticClass: "tool",
                              on: {
                                click: function($event) {
                                  _vm.openManagerTool(tool)
                                }
                              }
                            },
                            [
                              _c("v-icon", { staticClass: "tool-icon" }, [
                                _vm._v(_vm._s(tool.icon))
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "name" }, [
                                _vm._v(_vm._s(tool.name))
                              ]),
                              _vm._v(" "),
                              _c("v-icon", { staticClass: "chevron" }, [
                                _vm._v("mdi-chevron-right")
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "clear" })
                            ],
                            1
                          )
                        : _vm._e()
                    })
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "vo-card" }, [
                  _c("div", { staticClass: "vo-header" }, [
                    _vm._v("Default Assignees")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "vo-content" },
                    _vm._l(_vm.statuses, function(status, key) {
                      return Object.keys(_vm.statuses).length > 0
                        ? _c(
                            "div",
                            { key: key, staticClass: "status" },
                            [
                              _c("v-select", {
                                attrs: {
                                  autocomplete: "",
                                  multiple: "",
                                  "item-text": "fullName",
                                  "item-value": "_id",
                                  disabled: _vm.statusLockout !== false,
                                  label: status.name,
                                  loading:
                                    status.loading ||
                                    _vm.statusLockout === status,
                                  items: status.searchResults,
                                  "search-input": status.searchText
                                },
                                on: {
                                  keyup: function($event) {
                                    _vm.searchAssignees(key, status.searchText)
                                  },
                                  change: function($event) {
                                    _vm.changeAssignee(key, $event)
                                  },
                                  "update:searchInput": function($event) {
                                    _vm.$set(status, "searchText", $event)
                                  }
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "selection",
                                    fn: function(data) {
                                      return [
                                        _c(
                                          "div",
                                          { staticClass: "vo-user-chip" },
                                          [
                                            _c("vo-avatar", {
                                              staticClass: "avatar",
                                              attrs: {
                                                user: data.item,
                                                size: 24
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("div", { staticClass: "name" }, [
                                              _vm._v(_vm._s(data.item.fullName))
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "v-btn",
                                              {
                                                staticClass: "btn",
                                                attrs: {
                                                  fab: "",
                                                  flat: "",
                                                  small: ""
                                                },
                                                on: {
                                                  click: function($event) {
                                                    _vm.removeAssignee(
                                                      key,
                                                      data.item,
                                                      $event
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("v-icon", [
                                                  _vm._v("mdi-close")
                                                ])
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ]),
                                model: {
                                  value: status.assignees,
                                  callback: function($$v) {
                                    _vm.$set(status, "assignees", $$v)
                                  },
                                  expression: "status.assignees"
                                }
                              })
                            ],
                            1
                          )
                        : _c(
                            "div",
                            [
                              _c("v-progress-circular", {
                                staticStyle: { margin: "0 auto" },
                                attrs: {
                                  indeterminate: "",
                                  color: "primary",
                                  size: 40
                                }
                              })
                            ],
                            1
                          )
                    })
                  )
                ]),
                _vm._v(" "),
                _vm.hasPermissionsInProperty(["unit"], this.selected._id)
                  ? _c("div", { staticClass: "vo-card" }, [
                      _c("div", { staticClass: "vo-header" }, [
                        _vm._v("\n          Unit Types\n          "),
                        _c(
                          "div",
                          { staticClass: "vo-actions" },
                          [
                            _c(
                              "v-btn",
                              {
                                staticClass: "vo-icon-button",
                                attrs: { flat: "", fab: "", small: "" },
                                on: {
                                  click: function($event) {
                                    _vm.routeAddQuery(
                                      "dialog",
                                      "unit-type-manage"
                                    )
                                  }
                                }
                              },
                              [
                                _c("v-icon", { attrs: { medium: "" } }, [
                                  _vm._v("mdi-plus")
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          _vm.page.unitTypes.list
                            ? _c("vo-list", {
                                staticClass: "list",
                                attrs: { list: _vm.page.unitTypes.list },
                                scopedSlots: _vm._u([
                                  {
                                    key: "itemSlot",
                                    fn: function(item) {
                                      return _c(
                                        "div",
                                        { staticClass: "unit-type" },
                                        [
                                          _c("div", { staticClass: "name" }, [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$store.getters.unitType(
                                                  item.item
                                                ).name
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "buttons" },
                                            [
                                              _c(
                                                "v-btn",
                                                {
                                                  staticClass: "vo-icon-button",
                                                  attrs: {
                                                    fab: "",
                                                    small: "",
                                                    flat: ""
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      _vm.openEditDialog(item)
                                                    }
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "v-icon",
                                                    { attrs: { medium: "" } },
                                                    [_vm._v("mdi-pencil")]
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-btn",
                                                {
                                                  staticClass: "vo-icon-button",
                                                  attrs: {
                                                    fab: "",
                                                    small: "",
                                                    flat: ""
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      _vm.deleteUnitTypeDialog(
                                                        item
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "v-icon",
                                                    { attrs: { medium: "" } },
                                                    [_vm._v("mdi-delete")]
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    }
                                  }
                                ])
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ])
                  : _vm._e()
              ]
            : [_c("vo-empty-state", { attrs: { text: "SELECT A PROPERTY" } })]
        ],
        2
      ),
      _vm._v(" "),
      _c("vo-details-header")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-66b8e3a6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66b8e3a6","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PropertyDetails.vue
// module id = 545
// module chunks = 4